import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Paper,
  useTheme,
  alpha,
  Fade,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
  Alert,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Divider,
  CircularProgress,
  MobileStepper,
} from '@mui/material';
import {
  Speed as SpeedIcon,
  Assignment as ApplicationIcon,
  Assessment as ReportIcon,
  Verified as VerifiedIcon,
  CloudUpload as UploadIcon,
  CheckCircle as CheckIcon,
  ArrowForward as ArrowIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
  Map as MapIcon,
  Android as AndroidIcon,
  Apple as AppleIcon,
  Close as CloseIcon,
  Send as SendIcon,
  PlayArrow as PlayArrowIcon,
  CurrencyRupee as CurrencyRupeeIcon,
  CancelOutlined as CancelOutlinedIcon,
  TaskAltOutlined as TaskAltOutlinedIcon,
  WidgetsOutlined as WidgetsOutlinedIcon,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import GISPublicView from '../../components/GeosMap/GISPublicView';

import sikkimSeal from '../../static/assets/imgs/seal_of_sikkim_256px.png';
import homepageService from '../../services/homepageService';

import carouselImg1 from '../../static/assets/imgs/carousel/carousel_1.jpg';
import carouselImg2 from '../../static/assets/imgs/carousel/carousel_2.jpg';
import carouselImg3 from '../../static/assets/imgs/carousel/carousel_3.jpg';
import carouselImg4 from '../../static/assets/imgs/carousel/carousel_4.jpg';

const Home = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { isAuthenticated, role } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const [formErrors, setFormErrors] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [highlightButton, setHighlightButton] = useState(false);
  const contactSectionRef = useRef(null);

  // Carousel state
  const [activeStep, setActiveStep] = useState(0);

  
  const exms_citizen_apk_link = 'https://play.google.com/store/apps/details?id=com.itmangan.exms_citizen_app';
  const exms_citizen_ios_link = '#';

  const exms_field_insp_apk_link = 'https://play.google.com/store/apps/details?id=com.itmangan.natural_calamity_exgratia_management';
  const exms_field_insp_ios_link = '#';

  const exms_citizen_video_instruction_link = 'https://dacmangan.in/assets/audiovisual/ExMS_Citizen_app_info_video_fullAudio.mp4';
  const exms_citizen_video_thumbnail = 'https://dacmangan.in/assets/audiovisual/ExMS_Citizen_app_thumbnail.jpg';

  const exms_field_insp_video_instruction_link = 'https://dacmangan.in/assets/audiovisual/ExMS_Citizen_app_info_video_fullAudio.mp4';
  const exms_field_insp_video_thumbnail = 'https://dacmangan.in/assets/audiovisual/ExMS_Citizen_app_thumbnail.jpg';
  
  const carouselItems = [
    {
      title: 'Natural Calamity Ex-Gratia Management System',
      subtitle: 'Digital platform for seamless ex-gratia application processing and management',
      bgGradient: `linear-gradient(180deg, white 0%, ${alpha(theme.palette.primary.light, 0)} 30%, ${alpha(theme.palette.primary.main, 0.5)} 100%)`,
      bgImage: carouselImg1,
      buttonInfo: null,
    },
    {
      title: 'Feedback & Grievance Redressal',
      subtitle: 'Submit your queries and feedback directly to the Disaster Management Authority',
      bgGradient: `linear-gradient(180deg, white 0%, ${alpha(theme.palette.primary.light, 0)} 30%, ${alpha(theme.palette.primary.main, 0.5)} 100%)`,
      bgImage: null,
      buttonInfo: {
        text: 'Feedback / Grievance',
        icon: <SendIcon />,
        linkType: 'scroll',
        section: 'contact-section',
      },
    },
    {
      title: 'Fast & Transparent Processing',
      subtitle: 'Track your application status in real-time with our digital workflow system',
      bgGradient: `linear-gradient(180deg, white 0%, ${alpha(theme.palette.primary.light, 0)} 30%, ${alpha(theme.palette.primary.main, 0.5)} 100%)`,
      bgImage: carouselImg2,
      buttonInfo: {
        text: 'Track Application',
        icon: <ArrowIcon />,
        linkType: 'navigate',
        link: '/track-application',
      },
    },
    {
      title: 'Mobile App Support',
      subtitle: 'Apply for ex-gratia assistance through mobile apps',
      bgGradient: `linear-gradient(180deg, white 0%, ${alpha(theme.palette.primary.light, 0)} 30%, ${alpha(theme.palette.primary.main, 0.5)} 100%)`,
      bgImage: carouselImg3,
      buttonInfo: {
        text: 'Download Now',
        icon: <AndroidIcon />,
        linkType: 'navigate',
        link: exms_citizen_apk_link,
      },
    },
    {
      title: 'Geo-Spatial Analysis',
      subtitle: 'Advanced mapping and visualization of field inspection data',
      bgGradient: `linear-gradient(180deg, white 0%, ${alpha(theme.palette.primary.light, 0)} 30%, ${alpha(theme.palette.primary.main, 0.5)} 100%)`,
      bgImage: carouselImg4,
      buttonInfo: {
        text: 'Learn More',
        icon: <MapIcon />,
        linkType: 'navigate',
        link: '/about#geo-spatial-analysis',
      },
    },
  ];

  const maxSteps = carouselItems.length;

  // Statistics state
  const [statistics, setStatistics] = useState({
    total_applications: 0,
    disbursed_applications: 0,
    rejected_applications: 0,
    total_disbursed_amount: '0.00',
  });
  const [statsLoading, setStatsLoading] = useState(true);

  const handlePlayVideo = () => {
    setVideoLoaded(true);
  };

  // Auto-rotate carousel
  useEffect(() => {
    const timer = setInterval(() => {
      setActiveStep((prevActiveStep) => (prevActiveStep + 1) % maxSteps);
    }, 5000);

    return () => {
      clearInterval(timer);
    };
  }, [maxSteps]);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => (prevActiveStep + 1) % maxSteps);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => (prevActiveStep - 1 + maxSteps) % maxSteps);
  };

  // Fetch statistics on component mount
  useEffect(() => {
    const fetchStatistics = async () => {
      try {
        setStatsLoading(true);
        const data = await homepageService.getStatistics();
        setStatistics(data);
      } catch (error) {
        console.error('Error fetching statistics:', error);
      } finally {
        setStatsLoading(false);
      }
    };

    fetchStatistics();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setHighlightButton(true);
            // Remove highlight after 3 seconds
            setTimeout(() => {
              setHighlightButton(false);
            }, 3000);
          }
        });
      },
      {
        threshold: 0.3, // Trigger when 30% of the section is visible
      }
    );

    if (contactSectionRef.current) {
      observer.observe(contactSectionRef.current);
    }

    return () => {
      if (contactSectionRef.current) {
        observer.unobserve(contactSectionRef.current);
      }
    };
  }, []);

  const features = [
    {
      icon: <ApplicationIcon fontSize="large" color="primary" />,
      title: 'Easy Application Process',
      description: 'Citizens can apply for ex-gratia assistance through a simple WhatsApp Chatbot powered by AI or ExMS Citizen App.',
    },
    {
      icon: <SpeedIcon fontSize="large" color="primary" />,
      title: 'Fast Processing',
      description: 'Digital workflow ensures quick processing and timely updates on application status.',
    },
    {
      icon: <VerifiedIcon fontSize="large" color="primary" />,
      title: 'Transparent Tracking',
      description: 'Application status can be tracked in real-time, ensuring transparency in the process.',
    },
    {
      icon: <MapIcon fontSize="large" color="primary" />,
      title: 'Geo-Spatial Data',
      description: 'The data collected from field inspections can be visualized on maps for better analysis.',
    },

  ];

  const processSteps = [
    {
      icon: <ApplicationIcon />,
      title: 'Application Submission',
      description: 'Citizens submit applications using WhatsApp chat or ExMS Citizen App',
    },
    {
      icon: <UploadIcon />,
      title: 'Application Verification',
      description: 'Officials verify submitted information',
    },
    {
      icon: <ReportIcon />,
      title: 'Field Inspection',
      description: 'On-site assessment by inspection officers',
    },
    {
      icon: <CheckIcon />,
      title: 'Approval & Disbursement',
      description: 'Final approval and ex-gratia amount disbursement',
    },
  ];

  const handleGetStarted = () => {
    if (isAuthenticated) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
    // Clear error for this field when user starts typing
    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    
    if (!formData.name.trim()) {
      errors.name = 'Name is required';
    }
    
    if (!formData.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Email is invalid';
    }
    
    if (!formData.phone.trim()) {
      errors.phone = 'Phone number is required';
    } else if (!/^\d{10}$/.test(formData.phone.replace(/\D/g, ''))) {
      errors.phone = 'Phone number must be 10 digits';
    }
    
    if (!formData.subject.trim()) {
      errors.subject = 'Subject is required';
    }
    
    if (!formData.message.trim()) {
      errors.message = 'Message is required';
    }
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmitGrievance = (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    // TODO: actual API call to submit grievance
    console.log('Submitting grievance:', formData);
    
    // Simulate successful submission
    setSnackbar({
      open: true,
      message: 'Your message has been submitted successfully! We will get back to you soon.',
      severity: 'success',
    });
    
    // Reset form and close dialog
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
    });
    setDialogOpen(false);
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    // Clear form and errors when closing
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
    });
    setFormErrors({});
  };

  const handleScrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const formatNumber = (num) => {
    return num.toLocaleString('en-IN');
  };

  return (
    <Box sx={{ overflow: 'hidden' }}>
      {/* Hero Section with Carousel */}
      <Box
        sx={{
          position: 'relative',
          overflow: 'hidden',
          height: 'calc(100vh - 85px)',
          width: '100%',
        }}
      >
        {/* Carousel Slides */}
        {carouselItems.map((item, index) => (
          <Box
            key={index}
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              opacity: activeStep === index ? 1 : 0,
              visibility: activeStep === index ? 'visible' : 'hidden',
              backgroundImage: item.bgImage ? `${item.bgGradient}, url(${item.bgImage})` : item.bgGradient,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              transition: 'opacity 1s ease-in-out, visibility 1s ease-in-out',
            }}
          >
            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
              <Fade in={activeStep === index} timeout={1000}>
                <Grid 
                    container 
                    spacing={4} 
                    justifyContent="center" 
                    alignItems="center"
                    sx={{ textAlign: 'center' }}
                >
                    <Grid size={{ xs: 12 }}>
                        <Box 
                        display="flex" 
                        justifyContent="center"
                        sx={{
                            '& img': {
                                maxWidth: '100%',
                                height: 'auto',
                                backgroundColor: 'white',
                                borderRadius: '50%',
                                padding: theme.spacing(4),
                                overflow: 'hidden',
                            }
                        }}
                        >
                            <img 
                                src={sikkimSeal} 
                                alt="Sikkim Government Seal" 
                                style={{ width: '200px' }}
                            />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12 }}>                
                        <Typography 
                            variant="h2" 
                            component="h1" 
                            gutterBottom 
                            sx={{ 
                                fontWeight: 'bold',
                                fontSize: { xs: '2rem', md: '3.5rem' },
                                lineHeight: 1.2,
                                textShadow: '6px 6px 9px #000000',
                            }}
                        >
                            {item.title}
                        </Typography>
                        
                        <Typography 
                            variant="h4" 
                            component="h2" 
                            gutterBottom 
                            sx={{ 
                                // opacity: 0.9,
                                fontWeight: 300,
                                mb: 4,
                                backgroundColor: 'rgba(0,0,0,0.5)',
                                py: 2,
                                borderRadius: 1,
                                textShadow: '0px 2px 20px #FFFFFF80',
                            }}
                        >
                            {item.subtitle}
                        </Typography>

                        {
                          item.buttonInfo && (
                            <Button
                              variant="contained"
                              size="large"
                              component={
                                item.buttonInfo.linkType === 'scroll' ? undefined : 'a'
                              }
                              onClick={
                                item.buttonInfo.linkType === 'scroll' 
                                ? handleScrollToSection.bind(null, 'contact-section') 
                                : undefined
                              }
                              href={
                                item.buttonInfo.linkType !== 'scroll' 
                                ? item.buttonInfo.link 
                                : undefined
                              }
                              
                              target="_blank"
                              endIcon={item.buttonInfo.icon}
                              sx={{
                                bgcolor: theme.palette.background.paper,
                                '&:hover': {
                                  bgcolor: alpha(theme.palette.background.paper, 0.9),
                                  boxShadow: theme.shadows[8],
                                  transform: 'translateY(-2px)',
                                },
                                color: theme.palette.primary.main,
                                px: 4,
                                py: 1.5,
                                fontSize: '1.1rem',
                                transition: 'all 0.3s ease',
                              }}
                            >
                              {item.buttonInfo.text}
                            </Button>
                          )
                        }
                    </Grid>
                </Grid>
              </Fade>
            </Container>

            {/* Decorative Elements */}
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '300px',
                height: '300px',
                borderRadius: '50%',
                background: alpha('#fff', 0.05),
                transform: 'translate(150px, -150px)',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '250px',
                height: '250px',
                borderRadius: '50%',
                background: alpha('#fff', 0.03),
                transform: 'translate(-100px, 100px)',
              }}
            />
          </Box>
        ))}

        {/* Carousel Navigation */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 20,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 10,
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <IconButton
            size="small"
            onClick={handleBack}
            sx={{
              bgcolor: alpha('#fff', 0.3),
              color: 'white',
              '&:hover': {
                bgcolor: alpha('#fff', 0.5),
              },
            }}
          >
            <KeyboardArrowLeft />
          </IconButton>
          
          <MobileStepper
            steps={maxSteps}
            position="static"
            activeStep={activeStep}
            sx={{
              bgcolor: 'transparent',
              '& .MuiMobileStepper-dot': {
                bgcolor: alpha('#fff', 0.4),
              },
              '& .MuiMobileStepper-dotActive': {
                bgcolor: '#fff',
              },
            }}
            nextButton={<Box />}
            backButton={<Box />}
          />
          
          <IconButton
            size="small"
            onClick={handleNext}
            sx={{
              bgcolor: alpha('#fff', 0.3),
              color: 'white',
              '&:hover': {
                bgcolor: alpha('#fff', 0.5),
              },
            }}
          >
            <KeyboardArrowRight />
          </IconButton>
        </Box>
      </Box>

      {/* Homepage Statistics - disbursed appl, rejected appl, total appl, disbursed amt */}
      <Box sx={{ bgcolor: '#f8f9fa', py: 6 }}>
        <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
          {statsLoading ? (
            <Box display="flex" justifyContent="center" alignItems="center" py={8}>
              <CircularProgress />
            </Box>
          ) 
          : (
            <Grid container spacing={3} justifyContent="center">
              <Grid size={{ xs: 12, sm: 3 }}>
                <Card
                  sx={{
                    p: 3,
                    textAlign: 'center',
                    boxShadow: theme.shadows[2],
                    '&:hover': {
                      boxShadow: theme.shadows[6],
                      transform: 'translateY(-4px)',
                      transition: 'all 0.3s ease',
                    },
                  }}
                >
                  <CardContent>
                    <WidgetsOutlinedIcon sx={{ fontSize: 40, color: 'white', mb: 1, bgcolor: 'primary.light', borderRadius: '50%', width: 60, height: 60, p: 1 }} />
                    <Typography variant="h4" color="primary.light" gutterBottom>
                      {formatNumber(statistics.total_applications)}
                    </Typography>
                    <Typography variant="h6">
                      Total Applications
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <Card 
                  sx={{
                    p: 3,
                    textAlign: 'center',
                    boxShadow: theme.shadows[2],
                    '&:hover': {
                      boxShadow: theme.shadows[6],
                      transform: 'translateY(-4px)',
                      transition: 'all 0.3s ease',
                    },
                  }}
                >
                  <CardContent>
                    <TaskAltOutlinedIcon sx={{ fontSize: 40, color: 'white', mb: 1, bgcolor: 'success.light', borderRadius: '50%', width: 60, height: 60, p: 1 }} />
                    <Typography variant="h4" color="success.light" gutterBottom>
                      {formatNumber(statistics.disbursed_applications)}
                    </Typography>
                    <Typography variant="h6">
                      Disbursed Applications
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <Card 
                  sx={{
                    p: 3,
                    textAlign: 'center',
                    boxShadow: theme.shadows[2],
                    '&:hover': {
                      boxShadow: theme.shadows[6],
                      transform: 'translateY(-4px)',
                      transition: 'all 0.3s ease',
                    },
                  }}
                >
                  <CardContent>
                    <CancelOutlinedIcon sx={{ fontSize: 40, color: 'white', mb: 1, bgcolor: 'error.main', borderRadius: '50%', width: 60, height: 60, p: 1 }} />
                    <Typography variant="h4" color="error" gutterBottom>
                      {formatNumber(statistics.rejected_applications)}
                    </Typography>
                    <Typography variant="h6">
                      Rejected Applications
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <Card
                  sx={{
                    p: 3,
                    textAlign: 'center',
                    boxShadow: theme.shadows[2],
                    '&:hover': {
                      boxShadow: theme.shadows[6],
                      transform: 'translateY(-4px)',
                      transition: 'all 0.3s ease',
                    },
                  }}
                >
                  <CardContent>
                    <CurrencyRupeeIcon sx={{ fontSize: 40, color: 'white', mb: 1, bgcolor: 'success.main', borderRadius: '50%', width: 60, height: 60, p: 1 }} />
                    <Typography variant="h4" color="success" gutterBottom>
                      ₹{statistics.total_disbursed_amount}
                    </Typography>
                    <Typography variant="h6">
                      Total Disbursed Amount
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
        </Container>
      </Box>

      {/* GIS Dashboard Section */}
      <Box sx={{ py: 6 }}>
        <Container maxWidth="lg" sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h3" gutterBottom>
            Geo-Spatial Analysis Dashboard
          </Typography>
          <Typography variant="body1" paragraph>
            Interactive GIS dashboard to visualize field inspection data and gain insights into ex-gratia applications across different regions.
          </Typography>
        </Container>
        <Container maxWidth="lg">
          <GISPublicView />
        </Container>
      </Box>

      {/* Download Citizen App Section (Android, IOS) */}
      <Box sx={{ bgcolor: '#f0f2f5', py: 6 }}>
        <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom>
            Get the ExGratia Citizen App
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            href={exms_citizen_apk_link}
            target="_blank"
            sx={{ mr: 2, mb: { xs: 2, sm: 0 }, px: 3, py: 1.5 }}
          >
            <AndroidIcon sx={{ mr: 1 }} />
            Download for Android
          </Button>
          <Button
            variant="outlined"
            color="primary"
            href={exms_citizen_ios_link}
            target="_blank"
            sx={{ mr: 2, mb: { xs: 2, sm: 0 }, px: 3, py: 1.5 }}
            disabled
          >
            <AppleIcon sx={{ mr: 1 }} />
            Coming Soon for iOS
          </Button>

          <Typography variant="body1" paragraph sx={{ mt: 4 }}>
            Download the ExMS Citizen App to easily apply for ex-gratia assistance using your smartphone.
          </Typography>
        </Container>
        {/* ExMS Citizen App Video Instruction Section */}
        <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
          <Box sx={{ mt: 4, position: 'relative', paddingTop: '56.25%' }}>
            {!videoLoaded ? (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  cursor: 'pointer',
                  backgroundImage: `url(${exms_citizen_video_thumbnail})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundColor: '#000',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  '&:hover .play-button': {
                    transform: 'scale(1.1)',
                    backgroundColor: theme.palette.primary.dark,
                  },
                }}
                onClick={handlePlayVideo}
              >
                <Box
                  className="play-button"
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: '50%',
                    backgroundColor: theme.palette.primary.main,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                  }}
                >
                  <PlayArrowIcon sx={{ fontSize: 50, color: 'white', ml: 0.5 }} />
                </Box>
              </Box>
            ) : (
              <video
                controls
                autoPlay
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 'none',
                }}
              >
                <source src={exms_citizen_video_instruction_link} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
          </Box>
        </Container>
      </Box>

      {/* Download Field Inspectin App Section (Android, IOS) */}
      <Box sx={{ bgcolor: '#f8f9fa', py: 8}}>
        <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom>
            ExMS Field Inspection App *(Only for Field Officials)
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            href={exms_field_insp_apk_link}
            target="_blank"
            sx={{ mr: 2, mb: { xs: 2, sm: 0 }, px: 3, py: 1.5 }}
          >
            <AndroidIcon sx={{ mr: 1 }} />
            Download for Android
          </Button>
          <Button
            variant="outlined"
            color="primary"
            href={exms_field_insp_ios_link}
            target="_blank"
            sx={{ mr: 2, mb: { xs: 2, sm: 0 }, px: 3, py: 1.5 }}
            disabled
          >
            <AppleIcon sx={{ mr: 1 }} />
            Coming Soon for iOS
          </Button>

          <Typography variant="body1" paragraph sx={{ mt: 4 }}>
            Field Officials from Line Department needs to download the ExMS Field Inspection App.
          </Typography>
        </Container>
        {/* ExMS Field Inspection App Video Instruction Section*/}
        <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
          <Box sx={{ mt: 4, position: 'relative', paddingTop: '56.25%' }}>
            {!videoLoaded ? (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  cursor: 'pointer',
                  backgroundImage: `url(${exms_field_insp_video_thumbnail})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundColor: '#000',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  '&:hover .play-button': {
                    transform: 'scale(1.1)',
                    backgroundColor: theme.palette.primary.dark,
                  },
                }}
                onClick={handlePlayVideo}
              >
                <Box
                  className="play-button"
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: '50%',
                    backgroundColor: theme.palette.primary.main,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                  }}
                >
                  <PlayArrowIcon sx={{ fontSize: 50, color: 'white', ml: 0.5 }} />
                </Box>
              </Box>
            ) : (
              <video
                controls
                autoPlay
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 'none',
                }}
              >
                <source src={exms_field_insp_video_instruction_link} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
          </Box>
        </Container>
      </Box>

      {/* Features Section */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Typography variant="h3" align="center" gutterBottom sx={{ mb: 6 }}>
          Key Features
        </Typography>
        
        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
              <Fade in timeout={1000 + index * 200}>
                <Card 
                  sx={{ 
                    height: '100%',
                    textAlign: 'center',
                    p: 3,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: theme.shadows[8],
                    }
                  }}
                >
                  <CardContent>
                    <Box mb={2}>
                      {feature.icon}
                    </Box>
                    <Typography variant="h6" gutterBottom>
                      {feature.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {feature.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Fade>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Process Flow Section */}
      <Box sx={{ bgcolor: '#f8f9fa', py: 8 }}>
        <Container maxWidth="lg">
          <Typography variant="h3" align="center" gutterBottom sx={{ mb: 2 }}>
            Application Process
          </Typography>
          <Typography variant="h6" align="center" color="text.secondary" sx={{ mb: 6 }}>
            Simple steps to process natural calamity ex-gratia applications
          </Typography>

          <Grid container spacing={4} justifyContent="center">
            {processSteps.map((step, index) => (
              <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
                <Paper 
                  elevation={0}
                  sx={{ 
                    p: 3, 
                    textAlign: 'center', 
                    height: '100%',
                    border: '1px solid',
                    borderColor: 'divider',
                    position: 'relative',
                    '&:hover': {
                      borderColor: theme.palette.primary.main,
                      transform: 'translateY(-4px)',
                    },
                    transition: 'all 0.3s ease',
                  }}
                >
                  <Chip 
                    label={index + 1}
                    sx={{ 
                      position: 'absolute', 
                      top: -12, 
                      left: '50%', 
                      transform: 'translateX(-50%)',
                      bgcolor: theme.palette.primary.main,
                      color: 'white',
                      fontWeight: 'bold',
                    }} 
                  />
                  <Box sx={{ color: theme.palette.primary.main, mb: 2, mt: 2 }}>
                    {React.cloneElement(step.icon, { fontSize: 'large' })}
                  </Box>
                  <Typography variant="h6" gutterBottom>
                    {step.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {step.description}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Information Section */}
      <Container id="contact-section" ref={contactSectionRef} maxWidth="lg" sx={{ py: 8, scrollMarginTop: '80px' }}>
        <Grid container spacing={6}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="h4" gutterBottom>
              About Ex-Gratia Assistance
            </Typography>
            <Typography variant="body1" paragraph>
              The Government of Sikkim provides ex-gratia assistance to citizens affected by natural calamities 
              such as floods, landslides, earthquakes, and other natural disasters. This digital platform 
              streamlines the application process, making it easier for affected citizens to apply for and 
              receive timely assistance.
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              Eligible Calamities Include:
            </Typography>
            <List>
              {['Floods and Flash Floods', 'Landslides and Mudslides', 'Earthquakes', 'Hailstorms'].map((item) => (
                <ListItem key={item} disablePadding>
                  <ListItemIcon>
                    <CheckIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary={item} />
                </ListItem>
              ))}
            </List>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Card variant="outlined" sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Need Help? Feedback & Support
              </Typography>
              <Typography variant="body2" paragraph>
                Contact support team for assistance.
              </Typography>
              
              <Box sx={{ mb: 2 }}>
                <Box display="flex" alignItems="center" mb={1}>
                  <PhoneIcon sx={{ mr: 1, fontSize: 20 }} color="primary" />
                  <Typography variant="body2">+91-9242071005</Typography>
                </Box>
                <Box display="flex" alignItems="center" mb={1}>
                  <EmailIcon sx={{ mr: 1, fontSize: 20 }} color="primary" />
                  <Typography variant="body2">itsection.dacmangan@sikkim.gov.in</Typography>
                </Box>
                <Box display="flex" alignItems="center">
                  <LocationIcon sx={{ mr: 1, fontSize: 20 }} color="primary" />
                  <Typography variant="body2">IT Section, DAC Mangan, 737116</Typography>
                </Box>
              </Box>

              <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                Office Hours
              </Typography>
              <Typography variant="body2" sx={{ mb: 3 }}>
                Monday - Saturday: 10:00 AM - 4:00 PM
              </Typography>

              {/* Contact/Grievance Form Button */}
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleOpenDialog}
                startIcon={<SendIcon />}
                sx={{ 
                  mt: 2,
                  position: 'relative',
                  animation: highlightButton ? 'pulse 0.6s ease-in-out 3' : 'none',
                  '@keyframes pulse': {
                    '0%': {
                      boxShadow: `0 0 0 0 ${alpha(theme.palette.error.main, 1)}`,
                      backgroundColor: alpha(theme.palette.error.main, 1),
                    },
                    '30%': {
                      boxShadow: `0 0 0 10px ${alpha(theme.palette.error.main, 0.5)}`,
                      backgroundColor: alpha(theme.palette.error.main, 0.5),
                    },
                    '70%': {
                      boxShadow: `0 0 0 10px ${alpha(theme.palette.error.main, 0)}`,
                      backgroundColor: alpha(theme.palette.error.main, 0.2),
                    },
                    '100%': {
                      boxShadow: `0 0 0 0 ${alpha(theme.palette.error.main, 0)}`,
                      backgroundColor: alpha(theme.palette.error.main, 1),
                    },
                  },
                }}
              >
                Submit Query or Grievance
              </Button>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* Call to Action Section */}
      <Box 
        sx={{ 
          bgcolor: theme.palette.primary.main, 
          color: 'white', 
          py: 6, 
          textAlign: 'center' 
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h4" gutterBottom>
            Efficient, Transparent, and Accessible
          </Typography>
          <Typography variant="h6" paragraph sx={{ opacity: 0.9 }}>
            A pilot project of District Administration Centre, Mangan
          </Typography>
        </Container>
      </Box>

      {/* Contact/Grievance Modal Dialog */}
      <Dialog 
        open={dialogOpen} 
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
        disableEnforceFocus={false}
        disableAutoFocus={false}
        keepMounted={false}
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Submit Your Query or Grievance</Typography>
            <IconButton onClick={handleCloseDialog} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Box component="form" id="grievance-form" onSubmit={handleSubmitGrievance}>
            <TextField
              fullWidth
              label="Full Name"
              name="name"
              value={formData.name}
              onChange={handleFormChange}
              error={!!formErrors.name}
              helperText={formErrors.name}
              margin="normal"
              required
            />
            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleFormChange}
              error={!!formErrors.email}
              helperText={formErrors.email}
              margin="normal"
              required
            />
            <TextField
              fullWidth
              label="Phone Number"
              name="phone"
              value={formData.phone}
              onChange={handleFormChange}
              error={!!formErrors.phone}
              helperText={formErrors.phone}
              margin="normal"
              required
            />
            <TextField
              fullWidth
              label="Subject"
              name="subject"
              value={formData.subject}
              onChange={handleFormChange}
              error={!!formErrors.subject}
              helperText={formErrors.subject}
              margin="normal"
              required
            />
            <TextField
              fullWidth
              label="Message"
              name="message"
              value={formData.message}
              onChange={handleFormChange}
              error={!!formErrors.message}
              helperText={formErrors.message}
              margin="normal"
              multiline
              rows={4}
              required
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={handleCloseDialog} color="inherit">
            Cancel
          </Button>
          <Button 
            type="submit" 
            form="grievance-form"
            variant="contained" 
            color="primary"
            startIcon={<SendIcon />}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for form submission feedback */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Home;
